import { all, takeEvery, put, call, select } from 'redux-saga/effects'
import { notification } from 'antd'
import method from 'utilities/apiCaller'
import { validationCheckOnUploadDocuments } from 'utilities/transformer'

import actions from './actions'

const getPayconstructProducts = values => {
  const { accessToken, productName } = values
  return method.authPrivateGet(`brands/name/${productName}`, accessToken).then(response => {
    return response.data.data
  })
}

export function* GETPAYCONSTRUCTPRODUCTS(values) {
  const { payload } = values
  try {
    const response = yield call(getPayconstructProducts, payload)
    yield put({
      type: actions.GET_PAYCONSTRUCT_PRODUCTS_SUCCESS,
      value: response,
    })
  } catch (err) {
    yield put({
      type: actions.GET_PAYCONSTRUCT_PRODUCTS_FAILURE,
      payload: err,
    })
  }
}

const getPaymeroProducts = values => {
  const { accessToken, productName } = values
  return method.authPrivateGet(`brands/name/${productName}`, accessToken).then(response => {
    return response.data.data
  })
}

export function* GETPAYMEROPRODUCTS(values) {
  const { payload } = values
  try {
    const response = yield call(getPaymeroProducts, payload)
    yield put({
      type: actions.GET_PAYMERO_PRODUCTS_SUCCESS,
      value: response,
    })
  } catch (err) {
    yield put({
      type: actions.GET_PAYMERO_PRODUCTS_FAILURE,
      payload: err,
    })
  }
}

const getCustomerInfo = (id, token) => {
  return method.authPrivateGet(`entities/clients/${id}`, token).then(response => {
    return response.data.data
  })
}

export function* GETCUSTOMERDETAILS(value) {
  const { id, token } = value
  try {
    const response = yield call(getCustomerInfo, id, token)
    yield put({
      type: actions.GET_CUSTOMER_DETAILS_SUCCESS,
      value: response,
    })
  } catch (err) {
    yield put({
      type: actions.GET_CUSTOMER_DETAILS_FAILURE,
      payload: err,
    })
  }
}

const updateCustomerInfo = (id, values, token) => {
  return method.authPrivatePut(`entities/clients/${id}`, values, token).then(response => {
    return response.data.data
  })
}

export function* UPDATECUSTOMERDETAILS(value) {
  const { id, values, token, module } = value
  try {
    const response = yield call(updateCustomerInfo, id, values, token)
    yield put({
      type: actions.UPDATE_CUSTOMER_DETAILS_SUCCESS,
      value: response,
    })
    yield put({
      type: actions.GET_CUSTOMER_DETAILS,
      id,
      token,
    })

    if (module === 'companyInformation') {
      yield put({
        type: actions.GET_DOCUMENTS_QUESTIONS,
        tkn: token,
      })
      yield put({
        type: actions.GET_DOCUMENTS_FILE,
        token,
      })
    }
    if (module === 'regulationInformation') {
      yield put({
        type: actions.GET_DOCUMENTS_QUESTIONS,
        tkn: token,
      })
      yield put({
        type: actions.GET_DOCUMENTS_FILE,
        token,
      })
    }

    if (module !== 'off-notification') {
      notification.success({
        description: 'Updated successfully!',
      })
    }
  } catch (err) {
    yield put({
      type: actions.UPDATE_CUSTOMER_DETAILS_FAILURE,
      payload: err,
    })
    notification.error({
      description: 'Something is wrong!',
    })
  }
}

const getOperationQuestions = token => {
  return method.authPrivateGet(`questions/operations`, token).then(response => {
    return response.data.data
  })
}

export function* GETOPERATIONQUESTIONS(values) {
  const { tkn } = values
  try {
    const response = yield call(getOperationQuestions, tkn)
    yield put({
      type: actions.GET_OPERATION_QUESTIONS_SUCCESS,
      value: response,
    })
  } catch (err) {
    yield put({
      type: actions.GET_OPERATION_QUESTIONS_FAILURE,
      payload: err,
    })
  }
}

const getRegulatoryQuestions = token => {
  return method.authPrivateGet(`questions?category=risk`, token).then(response => {
    return response.data.data
  })
}

export function* GETREGULATORYQUESTIONS(values) {
  const { payload } = values
  try {
    const response = yield call(getRegulatoryQuestions, payload)
    yield put({
      type: actions.GET_REGULATORY_QUESTIONS_SUCCESS,
      value: response,
    })
  } catch (err) {
    yield put({
      type: actions.GET_REGULATORY_QUESTIONS_FAILURE,
      payload: err,
    })
  }
}

const getNextRegulatoryQuestions = values => {
  const { id, tkn, value } = values
  const request = {
    response: [value],
  }
  return method.authPrivatePut(`questions/${id}`, request, tkn).then(response => {
    return response.data.data
  })
}

export function* GETNEXTREGULATORYQUESTIONS(values) {
  const { payload } = values
  try {
    const response = yield call(getNextRegulatoryQuestions, payload)
    yield put({
      type: actions.GET_NEXT_REGULATORY_QUESTION_SUCCESS,
      value: response,
    })
  } catch (err) {
    yield put({
      type: actions.GET_NEXT_REGULATORY_QUESTION_FAILURE,
      payload: err,
    })
  }
}

const getGamingCountries = token => {
  return method.ccPrivateGet(`countries?limit=0&isGaming=true`, token).then(response => {
    return response.data.data
  })
}

export function* GETGAMINGCOUNTRIES(values) {
  const { payload } = values
  try {
    const response = yield call(getGamingCountries, payload)
    yield put({
      type: actions.GET_GAMING_COUNTRIES_SUCCESS,
      value: response,
    })

    // yield put({
    //   type: actions.GET_EU_COUNTRIES,
    //   value: payload,
    // })
    // yield put({
    //   type: actions.GET_GAMING_COUNTRIES,
    //   value: payload,
    // })
    yield put({
      type: actions.GET_FOREX_COUNTRIES,
      value: payload,
    })
  } catch (err) {
    yield put({
      type: actions.GET_GAMING_COUNTRIES_FAILURE,
      payload: err,
    })
  }
}

// const getEUCountries = token => {
//   return method.ccPrivateGet(`countries?limit=0&isEU=true&isForex=true`, token).then(response => {
//     return response.data.data
//   })
// }

// export function* GETEUCOUNTRIES(payload) {
//   try {
//     const response = yield call(getEUCountries, payload.value)
//     yield put({
//       type: actions.GET_EU_COUNTRIES_SUCCESS,
//       value: response,
//     })
//   } catch (err) {
//     yield put({
//       type: actions.GET_EU_COUNTRIES_FAILURE,
//       payload: err,
//     })
//   }
// }

// const getGamingCountries = token => {
//   return method.ccPrivateGet(`countries?limit=0&isGaming=true`, token).then(response => {
//     return response.data.data
//   })
// }

// export function* GETGAMINGCOUNTRIES(payload) {
//   try {
//     const response = yield call(getGamingCountries, payload.value)
//     yield put({
//       type: actions.GET_GAMING_COUNTRIES_SUCCESS,
//       value: response,
//     })
//   } catch (err) {
//     yield put({
//       type: actions.GET_GAMING_COUNTRIES_FAILURE,
//       payload: err,
//     })
//   }
// }

const getForexCountries = token => {
  return method.ccPrivateGet(`countries?limit=0&isForex=true`, token).then(response => {
    return response.data.data
  })
}

export function* GETFOREXCOUNTRIES(payload) {
  try {
    const response = yield call(getForexCountries, payload.value)
    yield put({
      type: actions.GET_FOREX_COUNTRIES_SUCCESS,
      value: response,
    })
  } catch (err) {
    yield put({
      type: actions.GET_FOREX_COUNTRIES_FAILURE,
      payload: err,
    })
  }
}

const getDocumentsFile = values => {
  const { token } = values
  return method.authPrivateGet(`documents/entity`, token).then(response => {
    return response.data.fileData
  })
}

export function* GETDOCUMENTSFILE(values) {
  try {
    const response = yield call(getDocumentsFile, values)
    yield put({
      type: actions.GET_DOCUMENTS_FILE_SUCCESS,
      value: response,
    })

    // documents upload status update
    const userState = yield select(state => state.user)
    const registerState = yield select(state => state.register)

    const statusUpdateOnDocumentsUpload = validationCheckOnUploadDocuments(registerState)
    const { progressLogs } = registerState
    const status = { isDocumentsUploadedDone: statusUpdateOnDocumentsUpload }
    Object.assign(progressLogs, status)
    yield put({
      type: actions.UPDATE_CUSTOMER_DETAILS,
      id: userState.clientId,
      values: { progressLogs },
      token: userState.token,
      module: 'off-notification',
    })
    // end
  } catch (err) {
    yield put({
      type: actions.GET_DOCUMENTS_FILE_FAILURE,
      payload: err,
    })
  }
}

const getPresignedUrl = value => {
  const { data, tkn } = value
  const request = {
    fileName: data.name,
    documentType: data.documentType,
  }
  return method.authPrivatePost(`file-upload`, request, tkn).then(response => {
    return response.data
  })
}

export function* GETPRESIGNEDURL(values) {
  const { payload } = values
  try {
    const response = yield call(getPresignedUrl, payload)
    yield put({
      type: actions.GET_PRESIGNED_URL_SUCCESS,
      value: response,
    })
    yield put({
      type: actions.ADD_DOCUMENT_FILES,
      payload: {
        data: payload.data,
        path: response.url,
      },
    })
  } catch (err) {
    yield put({
      type: actions.GET_PRESIGNED_URL_FAILURE,
      payload: err,
    })
  }
}

const addDocumentFiles = value => {
  const { data, path } = value
  return method.fileUploadPrivatePut(`${path}`, data).then(response => {
    return response.data.data
  })
}

export function* ADDDOCUMENTFILES(values) {
  const { payload } = values
  try {
    const response = yield call(addDocumentFiles, payload)
    const userState = yield select(state => state.user)

    yield put({
      type: actions.ADD_DOCUMENT_FILES_SUCCESS,
      value: response,
    })
    yield put({
      type: actions.GET_DOCUMENTS_FILE,
      token: userState.token,
    })
  } catch (err) {
    yield put({
      type: actions.ADD_DOCUMENT_FILES_FAILURE,
      payload: err,
    })
  }
}

const removeDocumentFiles = (values, token) => {
  return method.fileUploadPrivateDelete(`file-delete`, values, token).then(response => {
    return response.data.data
  })
}

export function* REMOVEDOCUMENTFILES(values) {
  const { payload, token } = values
  try {
    const response = yield call(removeDocumentFiles, payload, token)
    yield put({
      type: actions.REMOVE_DOCUMENT_FILES_SUCCESS,
      value: response,
    })
    yield put({
      type: actions.GET_DOCUMENTS_FILE,
      token,
    })
  } catch (err) {
    yield put({
      type: actions.REMOVE_DOCUMENT_FILES_FAILURE,
      payload: err,
    })
  }
}

const getDocumentsQuestions = token => {
  return method.authPrivateGet(`required-documents/entity`, token).then(response => {
    return response.data.data
  })
}

export function* GETDOCUMENTSQUESTIONS(values) {
  const { tkn } = values
  try {
    const response = yield call(getDocumentsQuestions, tkn)
    yield put({
      type: actions.GET_DOCUMENTS_QUESTIONS_SUCCESS,
      value: response,
    })
  } catch (err) {
    yield put({
      type: actions.GET_DOCUMENTS_QUESTIONS_FAILURE,
      payload: err,
    })
  }
}

const getAllStakeholders = token => {
  return method.authPrivateGet(`people`, token).then(response => {
    return response.data.data
  })
}

export function* GETSTAKEHOLERS(values) {
  const { token } = values
  try {
    const response = yield call(getAllStakeholders, token)
    yield put({
      type: actions.GET_ALL_STAKEHOLDERS_SUCCESS,
      value: response,
    })
  } catch (err) {
    yield put({
      type: actions.GET_ALL_STAKEHOLDERS_FAILURE,
      payload: err,
    })
  }
}

const addPerson = (body, token) => {
  return method.authPrivatePost(`people`, body, token).then(response => {
    return response.data.data
  })
}

export function* ADDSTAKEHOLER(value) {
  const { values, token } = value
  try {
    const response = yield call(addPerson, values, token)
    const userState = yield select(state => state.user)
    const registerState = yield select(state => state.register)
    yield put({
      type: actions.ADD_COMPANY_STAKEHOLDER_SUCCESS,
      value: response,
    })

    // add people overall status update
    const { progressLogs, totalSharePercentageAdded } = registerState
    if (totalSharePercentageAdded === 100) {
      const status = { isCompanyStakeholdersAddedDone: true }
      Object.assign(progressLogs, status)
      yield put({
        type: actions.UPDATE_CUSTOMER_DETAILS,
        id: userState.clientId,
        values: { progressLogs },
        token: userState.token,
      })
    } else {
      const status = { isCompanyStakeholdersAddedDone: false }
      Object.assign(progressLogs, status)
      yield put({
        type: actions.UPDATE_CUSTOMER_DETAILS,
        id: userState.clientId,
        values: { progressLogs },
        token: userState.token,
      })
    }

    // end

    yield put({
      type: actions.GET_ALL_STAKEHOLDERS,
      token,
    })
  } catch (err) {
    yield put({
      type: actions.ADD_COMPANY_STAKEHOLDER_FAILURE,
      payload: err,
    })
  }
}

const updatePerson = (body, id, token) => {
  return method.authPrivatePut(`people/${id}`, body, token).then(response => {
    return response.data.data
  })
}

export function* UPDATESTAKEHOLER(values) {
  const { value, id, token } = values
  try {
    const response = yield call(updatePerson, value, id, token)
    const userState = yield select(state => state.user)
    const registerState = yield select(state => state.register)
    yield put({
      type: actions.EDIT_COMPANY_STAKEHOLDER_SUCCESS,
      value: response,
    })

    // add people overall status update
    const { progressLogs, totalSharePercentageAdded } = registerState
    if (totalSharePercentageAdded === 100) {
      const status = { isCompanyStakeholdersAddedDone: true }
      Object.assign(progressLogs, status)
      yield put({
        type: actions.UPDATE_CUSTOMER_DETAILS,
        id: userState.clientId,
        values: { progressLogs },
        token: userState.token,
      })
    }
    // end

    yield put({
      type: actions.GET_ALL_STAKEHOLDERS,
      token,
    })
  } catch (err) {
    yield put({
      type: actions.EDIT_COMPANY_STAKEHOLDER_FAILURE,
      payload: err,
    })
  }
}

const deletePerson = (id, token) => {
  return method.authPrivateDelete(`people/${id}`, token).then(response => {
    return response.data.data
  })
}

export function* DELETESTAKEHOLER(values) {
  const { id, token } = values
  try {
    const response = yield call(deletePerson, id, token)
    yield put({
      type: actions.DELETE_COMPANY_STAKEHOLDER_SUCCESS,
      value: response,
    })
    yield put({
      type: actions.GET_ALL_STAKEHOLDERS,
      token,
    })
  } catch (err) {
    yield put({
      type: actions.DELETE_COMPANY_STAKEHOLDER_FAILURE,
      payload: err,
    })
  }
}

export default function* rootSaga() {
  yield all([takeEvery(actions.GET_PAYCONSTRUCT_PRODUCTS, GETPAYCONSTRUCTPRODUCTS)])
  yield all([takeEvery(actions.GET_PAYMERO_PRODUCTS, GETPAYMEROPRODUCTS)])
  yield all([takeEvery(actions.GET_CUSTOMER_DETAILS, GETCUSTOMERDETAILS)])
  yield all([takeEvery(actions.UPDATE_CUSTOMER_DETAILS, UPDATECUSTOMERDETAILS)])
  yield all([takeEvery(actions.GET_OPERATION_QUESTIONS, GETOPERATIONQUESTIONS)])
  yield all([takeEvery(actions.GET_REGULATORY_QUESTIONS, GETREGULATORYQUESTIONS)])
  yield all([takeEvery(actions.GET_NEXT_REGULATORY_QUESTION, GETNEXTREGULATORYQUESTIONS)])

  // regulatory countries
  // yield all([takeEvery(actions.GET_REGULATORY_COUNTRIES, GETREGULATORYCOUNTRIES)])

  // yield all([takeEvery(actions.GET_EU_COUNTRIES, GETEUCOUNTRIES)])
  yield all([takeEvery(actions.GET_GAMING_COUNTRIES, GETGAMINGCOUNTRIES)])
  yield all([takeEvery(actions.GET_FOREX_COUNTRIES, GETFOREXCOUNTRIES)])

  // upload documents
  yield all([takeEvery(actions.GET_DOCUMENTS_FILE, GETDOCUMENTSFILE)])
  yield all([takeEvery(actions.GET_PRESIGNED_URL, GETPRESIGNEDURL)])
  yield all([takeEvery(actions.ADD_DOCUMENT_FILES, ADDDOCUMENTFILES)])
  yield all([takeEvery(actions.REMOVE_DOCUMENT_FILES, REMOVEDOCUMENTFILES)])
  yield all([takeEvery(actions.GET_DOCUMENTS_QUESTIONS, GETDOCUMENTSQUESTIONS)])

  // adding the company stakeholders
  yield all([takeEvery(actions.GET_ALL_STAKEHOLDERS, GETSTAKEHOLERS)])
  yield all([takeEvery(actions.ADD_COMPANY_STAKEHOLDER, ADDSTAKEHOLER)])
  yield all([takeEvery(actions.EDIT_COMPANY_STAKEHOLDER, UPDATESTAKEHOLER)])
  yield all([takeEvery(actions.DELETE_COMPANY_STAKEHOLDER, DELETESTAKEHOLER)])
}
